import {
  MountedQuantitySelect,
  MountedDeleteElement,
  MountedRestoreElement,
  MountedBulkDeleteElement,
  MountedBulkRestoreElement,
} from "./types";

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeChangeCartOrderItemQuantities 数量変更処理
 * @param selector 指定した要素
 */
export const mountedQuantitySelect: MountedQuantitySelect = (
  existsElement,
  addEvent,
  invokeChangeCartOrderItemQuantities,
  selector
) => (getCartInfo, showBalloon, menuYear, menuNum) => {
  if (!existsElement(selector)) return;
  addEvent(selector, "change", invokeChangeCartOrderItemQuantities, {
    getCartInfo,
    showBalloon,
    menuYear,
    menuNum,
  });
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeDeleteCartOrderItem 削除処理
 * @param selector 指定した要素
 */
export const mountedDeleteElement: MountedDeleteElement = (
  existsElement,
  addEvent,
  invokeDeleteCartOrderItem,
  selector
) => (getCartInfo, showBalloon, menuYear, menuNum) => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeDeleteCartOrderItem, {
    getCartInfo,
    showBalloon,
    menuYear,
    menuNum,
  });
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeBulkDeleteCartOrderItem 削除処理
 * @param selector 指定した要素
 */
export const mountedBulkDeleteElement: MountedBulkDeleteElement = (
  existsElement,
  addEvent,
  invokeBulkDeleteCartOrderItem,
  selector
) => (getCartInfo, showBalloon, menuYear, menuNum) => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeBulkDeleteCartOrderItem, {
    getCartInfo,
    showBalloon,
    menuYear,
    menuNum,
  });
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeRestoreCartOrderItem 元に戻す処理
 * @param selector 指定した要素
 */
export const mountedRestoreElement: MountedRestoreElement = (
  existsElement,
  addEvent,
  invokeRestoreCartOrderItem,
  selector
) => (getCartInfo) => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeRestoreCartOrderItem, {
    getCartInfo,
  });
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeBulkRestoreCartOrderItem 元に戻す処理
 * @param selector 指定した要素
 */
export const mountedBulkRestoreElement: MountedBulkRestoreElement = (
  existsElement,
  addEvent,
  invokeBulkRestoreCartOrderItem,
  selector
) => (getCartInfo) => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeBulkRestoreCartOrderItem, {
    getCartInfo,
  });
};
